export default ['api', function (api) {
    return {
        getUrl: (eventType, eventId) => {
            return api.post(`api/url`, {
                type: eventType,
                eventId: eventId
            }).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/services/url.service.js